export default __webpack_public_path__ + "static/media/emoji19.a0ead726.png";